import TableCell from "@material-ui/core/TableCell";
import Box from "@material-ui/core/Box";
import React from "react";

export const HeaderCell =(props:{align?:'right'|'left';children:any})=>{
    let alignment = props.align || 'left';
    return (
        <TableCell
            align={alignment}
        >
            <Box color="#595959" fontWeight={600} fontSize="14px" lineHeight="20px">{props.children}</Box>
        </TableCell>
    );
}